export type PanelSize = 'wide' | 'medium' | 'narrow';

export const getPanelWidth = (size: PanelSize): number => {
  switch (size) {
    case 'wide':
      return 610;
    case 'medium':
      return 440;
    case 'narrow':
      return 360;
    default:
      return 360;
  }
};
